/*
 * Brents accordion rows (footer phone block, menu drawer) — open/close animation.
 *
 * <details> stays the mechanism: the markup is accessible and the rows still open without
 * JS. But the browser toggles `open` instantly, so this file drives the transition itself —
 * summary clicks are intercepted, `open` is set immediately on the way in and held until
 * the tween finishes on the way out, and the panel height is animated between 0 and its
 * content height. The inline height is cleared once the row settles so an open row keeps
 * growing with its contents.
 *
 * The listener sits on `document` in the CAPTURE phase on purpose: the drawer's rows are
 * inside <header-drawer>, whose submenu handler would otherwise treat the click as a
 * navigation. Stopping propagation there keeps it out — this used to be a separate inline
 * script in sections/header.liquid. Propagation is only stopped for drawer rows, so clicks
 * on footer rows still reach document-level handlers (e.g. Dawn closing an open disclosure).
 *
 * Duration comes from the CSS transition, so assets/component-brents-accordion.css stays
 * the single source of truth for it.
 */
(function () {
  'use strict';

  var FALLBACK = 400; // ms safety net, in case transitionend never fires
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Run `done` when the height tween ends, or when the fallback timer expires. Stored on the
     element so a click arriving mid-tween can land the previous one first. */
  function onSettled(details, panel, done) {
    var fired = false;

    function finish() {
      if (fired) return;
      fired = true;
      panel.removeEventListener('transitionend', handle);
      clearTimeout(timer);
      if (details.brentsAccordionSettle === finish) details.brentsAccordionSettle = null;
      done();
    }

    function handle(event) {
      if (event.target === panel && event.propertyName === 'height') finish();
    }

    panel.addEventListener('transitionend', handle);
    var timer = setTimeout(finish, FALLBACK);
    details.brentsAccordionSettle = finish;
  }

  function toggle(details) {
    var panel = details.querySelector(':scope > .brents-accordion__panel');
    if (!panel) return;

    if (details.brentsAccordionSettle) details.brentsAccordionSettle();

    if (reduceMotion.matches) {
      details.open = !details.open;
      return;
    }

    if (details.open) {
      panel.style.height = panel.scrollHeight + 'px';
      panel.offsetHeight; // reflow, so the browser has a start value to animate from
      panel.style.height = '0px';
      onSettled(details, panel, function () {
        details.open = false;
        panel.style.height = '';
      });
      return;
    }

    // scrollHeight only reports the content once the panel is actually rendered
    details.open = true;
    var target = panel.scrollHeight;
    panel.style.height = '0px';
    panel.offsetHeight;
    panel.style.height = target + 'px';
    onSettled(details, panel, function () {
      panel.style.height = '';
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var summary =
        event.target.closest && event.target.closest('.brents-accordion > .brents-accordion__summary');
      if (!summary) return;
      event.preventDefault(); // `open` is set around the tween instead
      if (summary.closest('header-drawer')) event.stopPropagation();
      toggle(summary.parentElement);
    },
    true
  );
})();
